/** @module Apparel/NewMaterialDrape **/
define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/comm/PostRequest",
	"csi/sessionConstants",
	"csi/table/New",
	"csi/xml"
], function (array, declare, lang, PostRequest, sessionConstants, New, xml) {

	return declare(New, {
		/**
		 * @override
		 * Disables Save and New Button
		 */
		_canRepeat: function () {
			return false;
		},

		/**
		 * @override
		 * Disables Save and go button
		 */
		_canNavigate: function () {
			return false;
		},


		/**
		 * @override
		 * Publish request to create new document
		 */
		process: function () {
			const fd = this.getFormData();
			const req = new PostRequest("Apparel", "CreateNewMaterialDrape");
			req.addParameter("Name", fd.getFieldValue(xml.ATTR_NAME));
			req.addParameter("ParentURL", this.m_urlParent);
			req.addParameter("SessionURL", sessionConstants.sessionUrl);
			req.addFiles(fd.getFieldValueAsFile("SourceFile"), "SourceFile");

			this.waitForPublish(req.post(), true);
		},

		/**
		 * @override
		 * Track URL of new document
		 */
		onPublishResponse: function (response) {
			this.m_urlNode = response.getResultNode().$URL;
		}
	});
});